/**
 * Custom hook to sync issuing SPV business draft data with Redux store
 * Consolidates all Redux dispatch operations for SPV business data
 */

import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { hydrateDisBizState } from "../../../features/distributor/biz";
import { Industry } from "../../../constants/enums";

export interface IssuingSPVBizDraftData {
  company: string;
  regNumber: string;
  dateOfIncorporation: string;
  legalStructure: string;
  legalStructureOthers: string;
  industryGroup: string;
  industryDropdownValues: Industry[];
  typeOfInstitute: string;
  industryOthers: string;
  countryISOCode: string;
  address: string;
  postal: string;
  website: string;
  userFirstName: string;
  userLastName: string;
}

/**
 * Hook to sync issuing SPV business draft data with Redux store
 * Uses hydrateDisBizState for efficient bulk updates
 */
export const useIssuingSPVBizDraftSync = () => {
  const dispatch = useDispatch();

  /**
   * Sync all SPV business data to Redux store
   * Uses hydrateDisBizState to update all fields in a single dispatch
   */
  const syncIssuingSPVBizToRedux = useCallback(
    (data: IssuingSPVBizDraftData) => {
      dispatch(hydrateDisBizState(data));
    },
    [dispatch]
  );

  return { syncIssuingSPVBizToRedux };
};
